<script>

import Vue from "vue";

import { required } from "vuelidate/lib/validators";
import axios from "axios";
import Multiselect from "vue-multiselect";

import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import listPlugin from "@fullcalendar/list";
import Swal from "sweetalert2";

/**
 * Landing component
 */
export default {
  page: {
    title: "",
    meta: [
      {
        name: "description",
        content: 'Avava Calendar is a modern and responsive calendar app. It is a full-featured calendar for planning, managing, and scheduling your daily tasks and events.',
      },
    ],
  },
  components: {
    Multiselect, FullCalendar,
  },
  data() {
    return {
      form: {
        room: null,
      },
      room_options: [],
      token: null,
      isLoadingPost: false,
      loadingGetPost: false,
      submitted: false,
      showCalendar: false,
      calendarType: 'day',
      calendarOptions: {
        customButtons: {
          switchViewMonth: {
            text: 'Month',
            click: () => {
              if(!this.isLoadingPost){
                this.calendarType = 'month'
                this.$refs.myCalendar.getApi().changeView('dayGridMonth')
                this.currentDate = this.$refs.myCalendar.getApi().getDate()
              }
            }
          },
          switchViewWeek: {
            text: 'List',
            click: () => {
              if(!this.isLoadingPost){
                this.calendarType = 'day'
                this.$refs.myCalendar.getApi().changeView('listWeek')
                this.currentDate = this.$refs.myCalendar.getApi().getDate()
              }
            }
          },
          buttonNext: {
            text: 'Next',
            icon: 'chevron-right',
            click: () => {
              if(!this.isLoadingPost){
                this.$refs.myCalendar.getApi().next()
                this.currentDate = this.$refs.myCalendar.getApi().getDate()
              }
            }
          },
          buttonPrev: {
            text: 'Prev',
            icon: 'chevron-left',
            click: () => {
              if(!this.isLoadingPost){
                this.$refs.myCalendar.getApi().prev()
                this.currentDate = this.$refs.myCalendar.getApi().getDate()
              }
            }
          },
          buttonToday: {
            text: 'Today',
            click: () => {
              if(!this.isLoadingPost){
                this.$refs.myCalendar.getApi().today()
                this.currentDate = this.$refs.myCalendar.getApi().getDate()
              }
            }
          }
        },
        headerToolbar: {
          left: "buttonPrev,buttonNext buttonToday",
          center: "title",
          right: "switchViewMonth,switchViewWeek",
        },
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          bootstrapPlugin,
          listPlugin,
        ],
        initialView: "listWeek",
        themeSystem: "bootstrap",
        events: [],
        // droppable: true,
        // eventResizableFromStart: true,
        // dateClick: this.dateClicked,
        eventClick: this.showEvent,
        // eventsSet: this.handleEvents,
        weekends: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        // draggable: true,
        // editable: true,
        // eventDrop: this.eventDrop
      },
      currentDate: new Date(),
      selectedPost: {},
      errorGetPost: [],
      showModalDetails: false,
    }
  },
  async mounted() {
    this.$store.dispatch("auth/logOut");
    
    this.getRoomList();
  },
  validations: {
    form: {
      room: { required }
    }
  },
  watch: {
    currentDate(oldValue, newValue){
      this.getList()
    }
  },
  methods: {
    getRoomList(){
      //fetch data from API
      axios.get(process.env.VUE_APP_API + '/public/room')
      .then(res => {
        this.room_options = res.data.data;
      })
    },
    onClickSubmit(){
      this.isLoadingPost = true;
      this.submitted = true;
      
      this.$v.$touch();

      if (this.$v.form.$invalid) {
        this.isLoadingPost = false
        return;
      }
      
      Vue.swal({
        icon: "info",
        title: "Loading ...",
        showConfirmButton: false,
        closeOnEsc: false,
        closeOnClickOutside: false,
      });

      this.showCalendar = true

      setTimeout(() => {
        this.getList()
      }, 500)
    },
    getList(){
      let buttonPrev = document.querySelector('.fc-buttonPrev-button');
      let buttonNext = document.querySelector('.fc-buttonNext-button');
      let buttonToday = document.querySelector('.fc-buttonToday-button');
      let buttonWeek = document.querySelector('.fc-switchViewWeek-button')
      let buttonMonth = document.querySelector('.fc-switchViewMonth-button')

      buttonPrev.disabled = true
      buttonNext.disabled = true
      buttonToday.disabled = true

      buttonPrev.classList.add('btn-light');
      buttonNext.classList.add('btn-light');
      buttonToday.classList.add('btn-light');
      buttonWeek.classList.add('btn-light');
      buttonMonth.classList.add('btn-light');

      this.isLoadingPost = true;
      this.calendarOptions.events = [];

      let filter = 'room_id=' + this.form.room.id

      let calendar = this.$refs.myCalendar.getApi()
      let date = null

      if(this.calendarType == 'month'){
        date = calendar.getDate().getFullYear() + '-' + (calendar.getDate().getMonth() + 1) + '-01'
        filter += '&view=month&date=' + date
      } else {
        date = calendar.getDate().getFullYear() + '-' + (calendar.getDate().getMonth() + 1) + '-' + calendar.getDate().getDate()
        filter += '&view=day&date=' + date
      }

      //fetch data from API
      axios.get(process.env.VUE_APP_API + '/public/post?' + filter)
      .then(res => {

        Vue.swal.close();

        this.gridData = res.data;
        this.list_error_messages = [];

        this.gridData.data.map((item, index) => {
          let color = 'bg-success';
          if(!item.is_editable){
            color = 'bg-dark';
          }

          let title = null

          if(item.is_announcement){
            color = 'bg-danger';
            title = item.room.name + ' - ANNOUNCEMENT';
          } else {
            title = (item.subject ? item.subject.name : '') + ' - ' + (item.item ? item.item.name : '');
          }

          this.calendarOptions.events.push({
            id: item.id,
            title: item.room.name + ' - ' + (item.is_announcement ? 'ANNOUNCEMENT' : item.subject.name),
            start: item.date,
            className: color
          });
        });

        Vue.swal({
          icon: "success",
          title: "Successfully loaded!",
          showConfirmButton: false,
          timer: 1000
        });
      })
      .catch(err => {
        if('response' in err){
          if('data' in err.response){
            if('message' in err.response.data){
              Vue.swal({
                icon: "error",
                title: err.response.data.data,
                showConfirmButton: false,
                timer: 3000
              });
            }
          }
        }
      })
      .finally(() => {
        this.isLoadingPost = false;
        buttonPrev.disabled = false;
        buttonNext.disabled = false;
        buttonToday.disabled = false;
        buttonWeek.disabled = false
        buttonMonth.disabled = false

        buttonPrev.classList.remove('btn-light');
        buttonNext.classList.remove('btn-light');
        buttonToday.classList.remove('btn-light');
        buttonWeek.classList.remove('btn-light');
        buttonMonth.classList.remove('btn-light');
      });
    },
    renderCalendarSubject(arg){
      var title = arg.event.title.split(' - ');
      var room_name = title[0];

      return room_name
    },
    renderCalendarTitle(arg){
      var title = arg.event.title.split(' - ');
      var event_title = title[1];

      return event_title
    },
    renderFileIcon(attachment){
      let filetype = attachment.name;
      
      if(filetype.includes('png') || filetype.includes('jpg') || filetype.includes('jpeg') || filetype.includes('gif') || filetype.includes('svg')){
        return 'bx bxs-file-image text-primary';
      } else if(filetype.includes('pdf')){
        return 'bx bxs-file-pdf text-danger';
      } else if(filetype.includes('word') || filetype.includes('doc') || filetype.includes('docx')){
        return 'bx bxs-file-doc text-primary';
      } else if(filetype.includes('excel') || filetype.includes('xls') || filetype.includes('xlsx')){
        return 'bx bxs-file-excel text-success';
      } else if(filetype.includes('powerpoint') || filetype.includes('ppt') || filetype.includes('pptx')){
        return 'bx bxs-file text-danger';
      } else {
        return 'bx bxs-file text-dark';
      }
    },
    onClickDownloadAttachment(attachment){
      window.open(attachment.download_link, '_blank');
    },
    showEvent(info) {
      this.showModalDetails = true
      this.loadingGetPost = true
      this.errorGetPost = []

      this.selectedPost = {
        is_editable: false
      }

      axios.get(process.env.VUE_APP_API + '/public/post/' + info.event.id)
      .then(res => {
        this.selectedPost = res.data.data;
      })
      .catch(err => {
        if('response' in err){
          if('data' in err.response){
            if('message' in err.response.data){
              this.errorGetPost = err.response.data.data;
            }
          }
        }
      })
      .finally(() => {
        this.loadingGetPost = false;
      });
    },
    navigateToLogin(){
      this.$router.push({ name: 'login'})
    },
    renderDescription(text){
      /* eslint-disable no-useless-escape */
      const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
      let formattedText = text.replace(urlPattern, '<a href="$1" target="_blank" rel="noopener noreferrer">Click here to open link</a>');
      
      // Replace new lines with <br> tags
      formattedText = formattedText.replace(/\r\n|\n|\r/g, '<br>');
      
      return formattedText;
    },
  }
};
</script>
<template>
  <div>
    <div class="home-btn d-block float-end">
      <span class="me-3 pointer" @click="showCalendar = false">
        <i class="fas fa-home h2"></i>
      </span>

      <span class="pointer" @click="navigateToLogin()">
        <i class="fas fa-user h2"></i>
      </span>
    </div>
    <section class="my-5 pt-sm-5">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center" v-if="!showCalendar">
            <div class="home-wrapper">
              <div>
                <router-link to="/" class="d-block auth-logo">
                  <img
                    src="@/assets/images/logo-dark.png"
                    alt=""
                    height="100"
                    class="auth-logo-dark mx-auto"
                  />
                  <img
                    src="@/assets/images/logo-light.png"
                    alt=""
                    height="100"
                    class="auth-logo-light mx-auto"
                  />
                </router-link>
              </div>

              <div class="row justify-content-center">
                <div class="col-sm-6">
                  <div class="maintenance-img">
                    <img
                      src="@/assets/images/checklist.png"
                      alt
                      class="img-fluid mx-auto d-block"
                    />
                  </div>
                </div>
              </div>
              <h3 class="mt-2">Avava School Calendar</h3>
              <p>Stay on top of your daily assignments! <br/>Choose an option below to view your calendar and upcoming tasks.</p>

              <div class="row mt-4">
                <div class="col-md-3">&nbsp;</div>
                <div class="col-md-6">
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title">Select Class</h4>
                      <multiselect v-model="form.room" :options="room_options" :close-on-select="true" :clear-on-select="false"
                        :preserve-search="true" placeholder="Select one of options" label="name" track-by="name">
                      </multiselect>

                      <div v-if="submitted && $v.form.room.$invalid" class="text-danger mt-1">
                        <span>Select class to continue</span>
                      </div>

                      <div class="col-12 mt-3 text-center">
                        <button :disabled="isLoadingPost" class="btn btn-primary px-5" type="button" @click="onClickSubmit()">Show Calendar</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">&nbsp;</div>
              </div>
              <!-- end row -->
            </div>
          </div>
          <div class="col-12" v-else>
            <div class="app-calendar">
              <FullCalendar
                :options="calendarOptions"
                :header="calendarOptions.headerToolbar"
                ref="myCalendar"
              >
              <template v-slot:eventContent='arg'>
                <strong>{{ renderCalendarSubject(arg) }}</strong>
                <div class="small text-white" v-if="calendarType == 'day'">{{ renderCalendarTitle(arg) }}</div>
              </template>
              </FullCalendar>
            </div>
          </div>
        </div>
      </div>
    </section>
    <b-modal
      v-model="showModalDetails"
      title="Post Details"
      title-class="text-black font-18"
      hide-footer
      body-class="p-3"
    >
      <div slot="modal-title">
        Post Details
      </div>
      <div class="row">
        <div class="col-12">
          <p class="card-text placeholder-glow" v-if="loadingGetPost">
            <span class="placeholder col-7"></span>
            <span class="placeholder col-4"></span>
            <span class="placeholder col-4"></span>
            <span class="placeholder col-6"></span>
            <span class="placeholder col-8"></span>
          </p>
          <div class="alert alert-danger" v-if="errorGetPost.length > 0">
            <ul>
              <li v-for="(error, index) in errorGetPost" :key="`error_${index}`">{{ error }}</li>
            </ul>
          </div>
        </div>

        <div class="row" v-if="!loadingGetPost && errorGetPost.length == 0">
          <div class="col-12">
            <strong>Date :</strong> {{ selectedPost.human_date }}
          </div>
          <div class="col-12" v-if="'year' in selectedPost">
            <span class="badge me-1 bg-primary">{{ selectedPost.year.name }}</span>
            <span class="badge me-1 bg-success">{{ selectedPost.room.name }}</span>
          </div>
          <div class="row mt-4" v-if="'description' in selectedPost">
            <div class="col-12 mt-1">
              <span class="badge me-1 even-larger-badge bg-info" v-if="selectedPost.subject">{{ selectedPost.subject.name }}</span>
              <span class="badge me-1 even-larger-badge bg-dark" v-if="selectedPost.item">{{ selectedPost.item.name }}</span>
              <span class="badge me-1 even-larger-badge bg-danger" v-if="selectedPost.is_announcement">ANNOUNCEMENT</span>
              <h5 class="font-size-14 mt-3" v-html="renderDescription(selectedPost.description)"></h5>
            </div>
            <div class="col-12 mt-3" v-if="selectedPost.attachments.length">
              <div v-for="(attachment, index) in selectedPost.attachments" :key="`attachment_${index}`" class="mb-2">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="text-truncate">
                    <i :class="renderFileIcon(attachment)"></i> {{ attachment.name.length > 20 ? attachment.name.substring(0, 20) + '...' : attachment.name }}
                    <button type="button" class="btn btn-link btn-sm text-primary" @click="onClickDownloadAttachment(attachment)">Download</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-4" v-if="'user' in selectedPost">
            <div class="col-12 mb-3">
              <strong class="font-size-14">Posted By</strong>
            </div>
            <div class="col-2">
              <div class="avatar-xs">
                <span class="avatar-title rounded-circle">{{selectedPost.user.name.charAt(0)}}</span>
              </div>
            </div>
            <div class="col-10">
              <h5 class="font-size-14 mb-1">
                <div class="text-dark">{{selectedPost.user.name}}</div>
                <div class="text-muted small mt-1" v-if="selectedPost.user.contact_no">{{selectedPost.user.contact_no}}</div>
                <div class="text-muted small mt-1" v-if="!selectedPost.user.contact_no"><i>No contact number</i></div>
              </h5>
            </div>
          </div>
        </div>
        <div class="col-12 row justify-space-between mt-4">
          <div class="col me-0 right">
            <button :disabled="loadingGetPost" class="btn btn-light" type="button" @click="showModalDetails = false">Close</button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<style>
  .fc-event-time, .fc-list-event-time, .fc-daygrid-event-dot, .fc-list-event-dot {
    display: none !important;
  }
  .fc-event-title, .fc-list-event-title {
    font-weight: normal !important;
    flex-grow: 0 !important;
  }
  .fc-event-title, .fc-list-event-title {
    font-size: 12px !important;
  }
  .fc-event {
    text-align: left !important;
  }
  /* .fc-list-event-title, .fc-list-event-graphic, .fc-event, .fc-daygrid-event-harness {
    background-color: green !important;
  } */
  .fc-daygrid-event-harness {
    margin-bottom: 3px;
  }
  .fc .fc-popover {
    z-index: 99 !important;
  }
  .fc .fc-list-event:hover td {
    background-color: #556ee6 !important;
  }
  .fc-view-harness .fc-view-harness-active {
    height: 30vh !important;
  }
  .fc .fc-more-popover .fc-popover-body {
    max-height: 250px !important;
    overflow: scroll !important;
    overflow-x: hidden !important;
  }
</style>